import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Подсказка под полем: «Без общежития анкету не принять».
 *
 * Не `Muted`: тот набран одиннадцатым кеглем — это подпись в карточке. Под
 * полем в макетах стоит десятый и третья ступень серого, и разница видна,
 * когда подсказка идёт сразу за набранным значением.
 */
export function FieldHint({
  children,
  tone = 'default',
}: {
  children: ReactNode;
  tone?: 'default' | 'negative';
}) {
  return (
    <span className={clsx(styles.fieldHint, tone === 'negative' && styles.fieldHintNegative)}>
      {children}
    </span>
  );
}
